import uiRouter from 'angular-ui-router';


var module = angular.module('app.ConstantModule', [
    uiRouter
    //import modules
]);

module.constant("CONSTANTS", {
    NODE_URL: "https://staging-nims-bml3000.globtech.in",
    // NODE_URL: "http://localhost:3000",
    // NODE_URL: "https://sqa-bml3000.globtech.in",
    FILE_UPLOAD_URL: "https://teamsqa4000.globtech.in",
    // FILE_UPLOAD_URL: "https://nims4000.benchmark.school",
    LRS_URL: "https://teamsqa3000.globtech.in",
    NODE_SOCKET_URL: "https://teamsqa3002.globtech.in",
    ARCHIVE_PAGE_SIZE: 100,
    ADMIN_ID: "super_admin",
    DEFAULT_SCHOOL_LOGO: "../../../src/img/school_dummy_logo.png",
    DEFAULT_PROFILE_IMAGE: "../../../src/img/dashboard/profile-pic.png",
    PMS_URL: "https://qcpms.globtech.in",
    SITE_URL: "https://teamsqa.globtech.in/",
    BUILD_VERSION: "4.0",
    SERVER_UPLOAD: "https://teamsqa4000.globtech.in/server-uploads",
    OXFORDTVM_CLIENTID: "688819777685-e5sdb510r6t05tmp1go46fjdbcvfjkov.apps.googleusercontent.com",
    OXFORDQLN_CLIENTID: "1070065984397-9n9os7dkj2c11fk22ljd68d8tmhmj7n0.apps.googleusercontent.com",
    OXFORDCLT_CLIENTID: "",
    NIMSDXB_CLIENTID: "47340146053-tjddjdu5ek23de49ki6euh0c367i7j95.apps.googleusercontent.com",
    NIMSSHJ_CLIENTID: "1070065984397-9n9os7dkj2c11fk22ljd68d8tmhmj7n0.apps.googleusercontent.com",
    NIMSALAIN_CLIENTID: "",
    TCS_CLIENTID: "92525820903-3c0lpbbtn8pulc70bcp7gi0mauaajij7.apps.googleusercontent.com",
    GOOGLE_ANALYTICS_MEASUREMENT_ID: "G-8KZ3H54C0M",
    OXFORD_CLIENT_ID: "688819777685-e5sdb510r6t05tmp1go46fjdbcvfjkov.apps.googleusercontent.com",
    NIMS_CLIENT_ID: "47340146053-tjddjdu5ek23de49ki6euh0c367i7j95.apps.googleusercontent.com",
    CLOUD_URL : "https://storage.googleapis.com/nims-content", //for proctoring ,
    GC_CLIENT_ID : "808404300357-chm4nloggfj56lbq5tfe407js7m3upe7.apps.googleusercontent.com",
    BM_REPORTS_URL : "https://bmreport.globtech.in",
    CSDASHBOARD_URL :"https://bmcs.docme.online"

});

module.constant('RESULT_ANALYSIS_CONSTANTS', {
    API_GET_SCHOOL_DETAILS: "/v0/school/details/",
    API_GET_STUDENT_RESULT: "/v0/analysis/student",
    API_GET_CONSOLIDATED_REPORT: "/v0/analysis/consolidated",
    API_GET_EXAM_CONSOLIDATED_REPORT: "/v0/analysis/exam/consolidated",
    API_SAVE_ANALYSIS_TEMPLATE: "/v0/analysis/template/save",
    API_DELETE_ANALYSIS_TEMPLATE: "/v0/analysis/template/delete",
    API_GET_SESSION_DETAILS: "/v0/analysis/filter/session",
    API_GET_CURRICULUM_DETAILS: "/v0/analysis/filter/curriculum",
    API_GET_CLASS_DETAILS: "/v0/analysis/filter/class",
    API_GET_SECTION_DETAILS: "/v0/analysis/filter/section",
    API_GET_BATCH_DETAILS: "/v0/analysis/filter/batch",
    API_GET_SUBJECT_DETAILS: "/v0/analysis/filter/subject",
    API_GET_EXAM_DETAILS: "/v0/analysis/filter/exam",
    API_GET_CONSOLIDATED_EXAM_DETAILS: "/v0/analysis/filter/consolidated/exam",
    API_GET_STUDENT_FILTER_DETAILS: "/v0/analysis/filter/all/student",
    API_GET_EXAM_FILTER_DETAILS: "/v0/analysis/filter/all/exam",
    API_GET_STUDENTS_REPORT: "/v0/analysis/report/students",
    API_GET_SUBJECT_REPORT: "/v0/analysis/report/subject",
    API_GET_EXAM_REPORT: "/v0/analysis/report/exam",
    API_GET_CLASS_REPORT: "/v0/analysis/report/class",
    API_GET_BATCH_REPORT: "/v0/analysis/report/batch",
    API_GET_SECTION_REPORT: "/v0/analysis/report/section",
    API_GET_GRADE_REPORT: "/v0/analysis/report/grade",
    API_GET_MARK_REPORT: "/v0/analysis/report/mark",
    API_GET_SECTION_GRADE_REPORT: "/v0/analysis/report/grade/section",
    API_GET_SECTION_MARK_REPORT: "/v0/analysis/report/mark/section",
    SCHOOL_DUMMY_LOGO: "../../img/school_dummy_logo.png",
    NOT_APPLICABLE: "NA",
    RESULT_ANALYSIS_EXAM_ORDER: ['Periodic Test-Half Yearly', 'Half Yearly', 'Periodic Test-Annual', 'Annual', 'Evaluation-1', 'Evaluation-2', 'Evaluation-3', 'Term 1', 'Term 2'],
    RESULT_ANALYSIS_GRADE_ORDER: ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'D', 'E1', 'A', 'B', 'C', 'ABSENT'],
    RESULT_ANALYSIS_MARK_ORDER: ['Outstanding (90 to 100)', 'Excellent (75 to 89)', 'Good (50 to 74)', 'Average (35 to 49)', 'Needs to improve (below 35)', 'ABSENT'],
    RESULT_ANALYSIS_CLASS_ORDER: ['Tiny tots', 'KG1', 'KG2', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    RESULT_ANALYSIS_BATCH_ORDER: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ'],
    RESULT_ANALYSIS_SECTION_ORDER: ['KG', '1 - 5 (Primary)', '6 - 8 (Middle)', '9 - 10 (Secondary)', '11 - 12 (Higher Secondary)'],
    RESULT_ANALYSIS_SLEEP_TIME: 1000,
    API_GET_TEACHER_CLASS: "/v0/analysis/filter/classteacherclassList",
});

module.constant('MARK_ENTRY_SAVE_CONSTANTS', {
    KG_CLASSES: ['class123', 'class1234'],
    API_GET_TERMS: '/v0/markentry/terms',
    API_AUTO_GENERATE_KG_REPORT: '/v0/reportcards/teacher/autogenerate',
    API_REPORT_CARD_GENERATE: '/v0/reportcards/teacher/start'
});

module.constant("ATTENDANCE_CONSTANTS", {
    API_GET_TIMETABLE_CONSOLE: "/v0/timetable/console",
    API_GET_BATCH_WISE_ATTENDANCE: "/v0/attendance/lite/batch-wise/attendance",
    API_GET_STUDENT_ATTENDANCE: "/v0/attendance/lite/batch-wise/students",
    API_GET_ATTENDANCE_CONSOLE: "/v0/attendance/console",
    API_GET_PERIODS: "/v0/attendance/periods",
    API_UPDATE_ATTENDANCE: "/v0/attendance/edit",
    API_MARK_ATTENDANCE: "/v0/attendance/mark",
    API_MARK_PREVIOUS_ATTENDANCE: "/v0/attendance/mark/previous",
    API_GET_TEACHERS: "/v0/set_availability/teacher/subjects",
    API_SAVE_ATTENDANCE_CONSOLE: "/v0/attendance/console/add",
    API_GET_SCHOOL_DETAILS: "/v0/school/details/",
    API_GET_CURRENT_DATE_TIME: "/v0/server/now",
    API_GET_STUDENT_MONTH_WISE_ATTENDANCE: "/v0/attendance/report/student/monthwise",
    API_GET_STUDENT_DATE_WISE_ATTENDANCE: "/v0/attendance/report/student/datewise",
    SCHOOL_DUMMY_LOGO: "../../../img/school_dummy_logo.png",
    API_GET_ADMIN_ATTENDANCE_FILTERS: "/v0/attendance/lite/filter/admin/",
    API_GET_TEACHER_ATTENDANCE_FILTERS: "/v0/attendance/lite/filter/teacher/",
    API_GET_MONTHLY_ATTENDANCE_DETAILS: "/v0/attendance/report/monthly",
    API_GET_YEARLY_ATTENDANCE_DETAILS: "/v0/attendance/report/yearly",
    API_GET_ATTENDANCE_DETAILS: "/v0/attendance/lite/batch-wise/attendance"
});

module.constant('APPOINTMENT_CONSTANT', {
    GET_SERVER_DATE: "/v0/server/now",
    GET_AVAILABILITY: "/v0/set_availability/teacher/not-available",
    GET_TEACHER_AVAILABILITY: "/v0/set_availability/mine",
    ADD_APPOINTMENT: "/v0/set_availability/add",
    EDIT_APPOINTMENT: "/v0/set_availability/edit",
    DELETE_APPOINTMENT: "/v0/set_availability/delete",
    PUBLISH_APPOINTMENT: "/v0/set_availability/update",
    GET_APPOINTMENTS_FOR_PARENT: "/v0/set_availability/get/available",
    API_GET_PARENT_DETAILS: "/v0/parent/portal/person/details/",
    API_GET_PARENT_CHILD_DETAILS: "/v0/parent/portal/child/details/",
    GET_REQUESTED_APPOINTMENTS: "/v0/set_availability/get/requested",
    SEND_PARENT_REQUEST: "/v0/set_availability/parent/request",
    API_GET_TEACHERS: "/v0/set_availability/teacher/subjects",
    DELETE_WITH_REASON: "/v0/set_availability/cancel/reason",
    ACCEPT_REQUEST: "/v0/set_availability/accept",
    REJECT_REQUEST: "/v0/set_availability/reject",
    CANCELLED_APPOINTMENTS: "/v0/set_availability/get/cancelled",
    DELETE_REASSIGN: "/v0/set_availability/reassign/delete",
    REASSIGN_APPOINTMENT: "/v0/set_availability/reassign"
});

module.constant("TIMETABLE_CONSTANTS", {
    API_GET_SUBJECTS: "/v0/set_availability/teacher/subjects",
    API_GET_TEACHER_SUBJECTS: "/v0/timetable/teacher/subjects",
    API_GET_TEACHER_TIMETABLE: "/v0/timetable/preview/teacher",
    API_GET_STUDENT_TIMETABLE: "/v0/timetable/preview/student",
    API_GET_PERSON: "/v0/endorsement/person_academics",
    API_GET_TIMETABLE_CONSOLE: "/v0/timetable/console",
    API_SAVE_TIMETABLE_CONSOLE: "/v0/timetable/console/add",
    API_GET_PREVIOUS_CONSOLE: "/v0/check_previous/timetable/attendance/appointment",
    API_GET_TEACHER_WITH_SUBJECTS: "/v0/set_availability/teacher/subjects",
    API_GET_TEACHER_AVAILABILITY: "/v0/timetable/teacher/availability",
    API_SAVE_TIMETABLE_ALLOCATION: "/v0/timetable/allocation/add",
    API_FORCE_SAVE_TIMETABLE_ALLOCATION: "/v0/timetable/allocation/force_update"
});
module.constant("ARCHIVE_CONSTANTS", {
    API_ARCHIVE_ACADEMIC_URL: "/v0/archives/filters/academic",
    API_ARCHIVE_THEME_URL: "/v0/archives/filters/theme",
    API_ARCHIVE_RESOURCE_URL: "/v0/archives/filters/resource-metadata",
    API_ARCHIVE_DATA_URL: "/v0/archives/list",
    API_ARCHIVE_RESOURCE_PREVIEW_URL: "/v0/archives/preview/resources",
    API_ARCHIVE_PLAN_PREVIEW_URL: "/v0/archives/preview/plan",
    API_ARCHIVE_QP_TEMPLATE_PREVIEW_URL: "/v0/archives/preview/qp-template",
    API_ARCHIVE_QP_PREVIEW_URL: "/v0/archives/preview/qp",
    API_ARCHIVE_QUESTION_PREVIEW_URL: "/v0/archives/preview/question",
    API_ARCHIVE_SYLLABUS_PREVIEW_URL: "/v0/archives/preview/syllabus",
    API_MY_ARCHIVE_DATA_URL: "/v0/archives/my-list",
    API_MY_ARCHIVE_EDIT_NOTE_URL: "/v0/archives/edit-my-notes",
    API_MY_ARCHIVE_DELETE_ARCHIVE_URL: "/v0/archives/delete-my-archive",
    API_MY_ARCHIVE_DELETE_THEME_URL: "/v0/archives/delete-my-theme",
    API_SEND_APPROVAL_ARCHIVE_DATA_URL: "/v0/archives/send-approval-list",
    API_ARCHIVE_APPROVER_LIST_URL: "/v0/archives/approver-list",
    API_TO_APPROVE_ARCHIVE_DATA_URL: "/v0/archives/to-approve-list",
    API_ARCHIVE_SEND_FOR_APPROVAL_URL: "/v0/archives/send-for-approval",
    API_ARCHIVE_APPROVE_URL: "/v0/archives/apporve",
    API_ARCHIVE_PUBLISH_LIST_URL: "/v0/archives/publish-list",
    API_ARCHIVE_PUBLISH_ALL_LIST_URL: "/v0/archives/publish-all-list",
    API_ARCHIVE_PUBLISH_URL: "/v0/archives/publish",
    API_ARCHIVE_REJECTED_LIST_URL: "/v0/archives/publish-rejected-list",
    API_ARCHIVE_LINK_THEME_FILTER_URL: "/v0/archives/link-themes/filters",
    API_ARCHIVE_LINK_THEME_ALL_URL: "/v0/archives/link-themes/all-themes",
    API_ARCHIVE_LINK_THEME_DEFAULT_URL: "/v0/archives/link-themes/default-themes",
    API_ARCHIVE_LINK_THEME_SAVE_URL: "/v0/archives/link-themes/save",
    API_ARCHIVE_SYLLABUS_GET_THEMES_URL: "/v0/archives/syllabus/get-themes",
    API_ARCHIVE_SYLLABUS_SAVE_URL: "/v0/archives/syllabus/save",
    API_ARCHIVE_THEME_SAVE_URL: "/v0/archives/themes/save",
    API_ARCHIVE_RESOURCE_SAVE_URL: "/v0/archives/resource/save",
    API_ARCHIVE_CREATE_QP: "/v0/archives/question-paper/create",
    API_ARCHIVE_EDIT_QP: "/v0/archives/question-paper/edit",
    API_ARCHIVE_AUTOFORMAT_URL: "/v0/archives/question-paper/auto-format",
    API_ARCHIVE_DELETE_QUES_URL: "/v0/archives/question-paper/del-ques",
    API_ARCHIVE_SAVE_QP_URL: "/v0/archives/question-paper/save",
    API_ARCHIVE_SAVE_SECTION_QP_URL: "/v0/archives/question-paper/save-section",
    ARCHIVE_RESOURCE_TYPES: [{
        name: "Google Docs",
        _id: "googledocs"
        // }, {
        //     name: "Interactive Anime",
        //     _id: "flash"
    }, {
        name: "Khan Academy",
        _id: "khanAcademy"
    }, {
        name: "PDF",
        _id: "pdf"
    }, {
        name: "Reference Books",
        _id: "refbooks"
    }, {
        name: "Video",
        _id: "video"
    }, {
        name: "You Tube",
        _id: "utubeVideo"
    }, {
        name: "Web Links",
        _id: "weblinks"
    }],
    ARCHIVE_ALL_STATUS_LIST: [{
        name: "Approved",
        _id: "approved"
    }, {
        name: "Published",
        _id: "published"
    }],
    ARCHIVE_MY_STATUS_LIST: [{
        name: "Approved",
        _id: "approved"
    }, {
        name: "Created",
        _id: "created"
    }, {
        name: "Rejected",
        _id: "rejected"
    }, {
        name: "Pending",
        _id: "sent_for_approval"
    }, {
        name: "Published",
        _id: "published"
    }],
    ARCHIVE_QUESTION_TYPE_LIST: [{
        name: "Multiple Choice Question",
        _id: "MCQ",
        isPractice: true
    }, {
        name: "Fill in the Blanks",
        _id: "FIB",
        isPractice: true
    }, {
        name: "True or False",
        _id: "TF",
        isPractice: true
    }, {
        name: "One Word Question",
        _id: "OWQ",
        isPractice: true
    }, {
        name: "Match the Following",
        _id: "MTF",
        isPractice: true
    }, {
        name: "Short Answer",
        _id: "SA",
        isPractice: false
    }, {
        name: "Long Answer",
        _id: "LA",
        isPractice: false
    },
    /*{
        name: "Drawing",
        _id: "DRAW",
        isPractice: false
    }, {
        name: "Asl - Listening",
        _id: "ASLLISTEN",
        isPractice: false
    }, {
        name: "Asl - Speaking",
        _id: "ASLSPEAK",
        isPractice: false
    },*/
    {
        name: "Passage",
        _id: "passage",
        isPractice: false
    }
    ],
    ARCHIVE_QUESTION_TYPE_LIST_LW: [{
        name: "Multiple Choice Question",
            _id: "MCQ",
            isPractice: true
        }, {
            name: "Short Answer",
            _id: "SA",
            isPractice: false
        }
    ],
    ARCHIVE_EXAM_TYPES: [{
        name: 'Practice Exam',
        _id: 'Practice'
    }, {
        name: 'Assessment Exam',
        _id: 'Assesment'
    }],
    ARCHIVES_LEVELS: [1, 2, 3],
    ARCHIVE_TABS: [{
        imgActiveSrc: "../../../img/archives/syllabus-blue.png",
        imgInActiveSrc: "../../../img/archives/syllabus-white.png",
        _id: "syllabus",
        name: "Syllabus",
        isActive: false,
        isVisible: false,
    }, {
        imgActiveSrc: "../../../img/archives/theme-blue.png",
        imgInActiveSrc: "../../../img/archives/theme-white.png",
        _id: "themes",
        name: "Themes",
        isActive: false,
        isVisible: false,
    }, {
        imgActiveSrc: "../../../img/archives/resource-blue.png",
        imgInActiveSrc: "../../../img/archives/resource-white.png",
        _id: "resources",
        name: "Resources",
        isActive: false,
        isVisible: false,
    }, {
        imgActiveSrc: "../../../img/archives/tp-blue.png",
        imgInActiveSrc: "../../../img/archives/tp-white.png",
        _id: "teachingPlan",
        name: "Plans",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/note-blue.png",
        imgInActiveSrc: "../../../img/archives/note-white.png",
        _id: "notes",
        name: "Notes",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/questions-blue.png",
        imgInActiveSrc: "../../../img/archives/questions-white.png",
        _id: "question",
        name: "Questions",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/qp-blue.png",
        imgInActiveSrc: "../../../img/archives/qp-white.png",
        _id: "qp",
        name: "Question Paper",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/qp-temp-blue.png",
        imgInActiveSrc: "../../../img/archives/qp-temp-white.png",
        _id: "qp_template",
        name: "Question Template",
        isActive: false,
        isVisible: false
    }],
    ARCHIVE_PASSAGE_SELECTION: [{
        _id: true,
        name: "Questions With Passage"
    }, {
        _id: false,
        name: "Questions Without Passage"
    }],
    ARCHIVE_MAPPED_TABS: [{
        _id: "syllabus",
        name: "syllabus"
    }, {
        _id: "themes",
        name: "themes"
    }, {
        _id: "resources",
        name: "resourceContent"
    }, {
        _id: "teachingPlan",
        name: "planContent"
    }, {
        _id: "notes",
        name: "notesContent"
    }, {
        _id: "question",
        name: "questionsContent"
    }, {
        _id: "qp",
        name: "qpContent"
    }, {
        _id: "qp_template",
        name: "qpTempContent"
    }],
    ARCHIVE_MAPPED_CREATE_TABS: [{
        _id: "syllabus",
        name: "syllabus"
    }, {
        _id: "themes",
        name: "themes"
    }, {
        _id: "resources",
        name: "resourceContent"
    }, {
        _id: "question",
        name: "questionsContent"
    }, {
        _id: "qp",
        name: "qpContent"
    }],
    ARCHIVE_MAPPED_APPROVAL_TABS: [{
        _id: "syllabus",
        name: "syllabus",
    }, {
        _id: "resources",
        name: "resourceContent"
    }, {
        _id: "question",
        name: "questionsContent"
    }, {
        _id: "qp",
        name: "qpContent"
    }],
    ARCHIVE_MAPPED_APPROVE_TABS: [{
        _id: "syllabus",
        name: "approveSyllabus"
    }, {
        _id: "resources",
        name: "approveResourceContent"
    }, {
        _id: "question",
        name: "approveQuestionsContent"
    }, {
        _id: "qp",
        name: "approveQpContent"
    }],
    ARCHIVE_MAPPED_SCHOOL_TABS: [{
        _id: "resources",
        name: "publishResources"
    }, {
        _id: "question",
        name: "publishQuestions"
    }],
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
        // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs",
    },
    QUESTION_TYPE_DETAILS: {
        MCQ: "Multiple choice question",
        FIB: "Fill in the blanks",
        MTF: "Match the following",
        OWQ: "One word question",
        TF: "True or False",
        SA: "Short answer question",
        LA: "Long answer question",
        IBT_MCQ: "IBT - Multiple choice question",
        IBT_FIB: "IBT - Fill in the blanks",
        DRAW: "Drawing",
        ASLSPEAK: "ASL - Speaking",
        ASLLISTEN: "ASL - Listening",
        PASSAGE: "Passage"
    },
    KHANACADEMY_URL: "https://www.khanacademy.org/api/v1/videos/"
})

module.constant('GOOGLE_CLASSROOM_CONSTANTS', {
    API_GET_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/get',
    API_ADD_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/add',
    API_GET_CLASSROOM_TOPICS: '/v0/google_classroom/classroom/topics',
    API_EXPORT_TO_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/export',
    API_IMPORT_FROM_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/import'
})
module.constant('pulishedReportCardsConstants', {
    NO_FEESCHOOLIDS: ['2FwuqhgeoKt6SQiCG']
})
module.constant('OPTIONAL_SCHOOLFONTS', {
    CANTERBURY_FONT_SCHOOLS: ['2ebFyzgjEwmdvep5L', 'f5BCz8T7LqzpFsSP3']
})
module.constant('NO_SHARE_AFL_SCHOOLS', {
    SCHOOL_IDS: ['a4C45mm9XLYagBQgH']
})
module.constant('RC_CONSTANTS_', {
    PORT_FOLIO_AS_NB_SCHOOLS: ['2ebFyzgjEwmdvep5L']
})
module.constant('PASS_CMP_CHECK', {
    PASS_CMP_CHECK_CLASSES: ['KG1','KG2','1','2','3']
})
module.constant('QP_HANDLING_CONSTANTS', {
    QP_NOTVISBLE_DEFAULT_PARENT_SCHOOLS: ['CPpbKPQTcuG97i3kv']
})


// WEBPACK FOOTER //
// ./src/constantModule.js